import $ from 'jquery';
import { fetch } from '../../../api/js/global';

const searchInput = '.js-autocomplete-input',
      searchBtn = '.header-search__btn',
      searchResults = '.header-search__results-list',
      searchSection = '.header-search',
      suggestedList = '.header-search__list--suggested';

let xhr,
    url = '',
    inputValue = '',
    suggestedEl = '',
    currentFocus;

/* Init module */
const init = () => {

    if (typeof $(searchSection).attr('data-url') !== 'undefined' && $(searchSection).attr('data-url') !== '') {
        url = $(searchSection).attr('data-url');
    }

    inputValue = $(searchInput).val();

    bind();
};

const autocomplite = (value) => {
    inputValue = value;

    if (value.length > 2) {

        $(searchResults).addClass('loading');

        if (xhr) {
            xhr.abort();
        }
        if (url) {

            xhr = fetch('GET', url, 'query=' + value, function(
                data
            ) {
                $(searchSection)
                    .find(searchResults)
                    .html(data)
                    .removeClass('loading');

                // get suggested elements
                $(suggestedList).length && (suggestedEl = $(suggestedList).find('li'));
                //$(searchInput).parent().attr('aria-expanded','true');
                $(searchInput).attr('aria-expanded','true');
            });

            xhr.fail(function(er) {

                $(searchResults).removeClass('loading');
                console.warn('Getting data error: ' + er.status + ' - ' + er.statusText);
            });
        }
    } else {
        $(searchSection).find(searchResults).html('');
        $(searchInput).attr('aria-expanded','false');
    }
};

const bind = () => {

    $(searchInput).on('input focus', function() {

        autocomplite($(this).val());
        currentFocus = -1;
    });

    $(document).on('click focus keyup', function (e) {
        if (!$(e.target).is(searchSection + ' *')) {

            $(searchSection).find(searchResults).html('');
            $(searchInput).val(inputValue).attr('aria-expanded','false');
        }
    });

    $(searchSection).on('click',suggestedList + ' li',function(e){
        e.preventDefault();

        $(searchInput).val($(this).text());
        $(searchBtn).trigger('click');
    });

    /* execute a function presses a key on the keyboard */
    $(searchInput).on('keydown', function(e) {

        if (e.key === "ArrowDown") {
            /* If the arrow DOWN key is pressed,
             increase the currentFocus variable */
            currentFocus++;
            addActive(suggestedEl);

        } else if (e.key === "ArrowUp") { //up
            /* If the arrow UP key is pressed,
             decrease the currentFocus variable */
            currentFocus--;
            addActive(suggestedEl);
        } else if (e.key === "Enter") {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            if (currentFocus > -1) {
                /* and simulate a click on the "active" item */
                if (suggestedEl.length) $(suggestedEl.eq(currentFocus)).click(); 
            }
        }
    });
};

function addActive(el) {
    /*a function to classify an item as "active":*/
    if (!el) return false;
    /*start by removing the "active" class on all items:*/
    $(el).removeClass('autocomplete-active').attr('aria-selected','false');
    $(searchInput).attr('aria-activedescendant','');

    if (currentFocus >= el.length) {
        currentFocus = -1;
        $(searchInput).val(inputValue);
        return false;
    }
    if (currentFocus < 0) {
        currentFocus = (el.length );
        $(searchInput).val(inputValue);
        return false;
    }
    /*add class "autocomplete-active":*/
    $(el.eq(currentFocus)).addClass('autocomplete-active').attr('aria-selected','true');
    $(searchInput).val($(el.eq(currentFocus)).text());
    $(searchInput).attr('aria-activedescendant',$(el.eq(currentFocus)).attr('id'));
}

searchInput.length && init();
